const FiberCompanyListSkeleton = () => {
	return (
		<div className="overflow-hidden">
			<div className="flex gap-4 overflow-x-auto px-4 lg:px-8 pb-3">
				{[1, 2, 3, 4, 5, 6].map((item) => (
					<div
						key={item}
						className="shrink-0 h-12 py-1 px-4 rounded-full border-2 border-solid border-gray-300 bg-gray-200 animate-pulse"
						style={{ width: "120px" }}
					/>
				))}
			</div>
		</div>
	);
};

export default FiberCompanyListSkeleton;